// src/api_scripts/get/getOutdialAniEntries.js
import { createApiClient } from "../apiClient";

const getOutdialAniEntries = async (outdialAniId, orgId, accessToken, setProgress) => {
  const apiClient = createApiClient(accessToken);
  const relativeUri = `organization/${orgId}/outdial-ani/${outdialAniId}/outdial-ani-entry`;

  try {
    const response = await apiClient.get(relativeUri);
    const result = response.data;

    // Handle response structure - extract data array if available
    const entries = result.data || result || [];

    if (Array.isArray(entries)) {
      console.log(`Get OutDial ANI Entries for ANI ${outdialAniId}:`, entries.length, "items");
      return entries;
    } else {
      console.warn(`OutDial ANI Entries response for ANI ${outdialAniId} was not an array:`, result);
      return [];
    }

  } catch (error) {
    // If it's a 404, this ANI has no entries or the API doesn't exist
    if (error.message && (error.message.includes('404') || error.message.includes('Request failed with status code 404'))) {
      console.warn(`OutDial ANI Entries not available for ANI ${outdialAniId} (404). This is normal if the ANI has no entries.`);
      return []; // Return empty array instead of throwing error
    }

    console.error(`Error fetching OutDial ANI Entries for ANI ${outdialAniId}:`, error);
    throw error; // Re-throw other errors
  }
};

export default getOutdialAniEntries;